/** @fileoverview Non-interactive loading placeholders using the application's surface tokens. Parents own request lifetime and accessible loading context. */
import React from 'react';
export function Skeleton({ width, height = '1rem', borderRadius = 4, className, style }) {
  return <span aria-hidden="true" className={className} style={{ display: 'block', background: 'var(--kc-surface-inset)', width, height, borderRadius, ...style }} />;
}
